import React, { PureComponent } from 'react';
import { View, ListView, TouchableOpacity } from 'react-native';
import Row from './portfolio-position-row';
import styles from './portfolio.position.search.styles';
import { Small } from '@dbk/ui-text';
import ScrollableLayout from '../../../../components/common/scrollable-layout';
import { createContainer } from '@dbk-legacy/muster/react';
import slice from 'lodash/slice';
import NavigationArrow from '../../../../components/common/navigation-arrow';
import { NavigationList, NavigationListItem } from '@dbk/ui-list'

class PortfolioPositionSearch extends PureComponent {
  constructor(props) {
    super(props);
    // const ds = new ListView.DataSource({
    //   rowHasChanged: (r1, r2) => r1 !== r2,
    // });
    // const ds1 = new ListView.DataSource({
    //   rowHasChanged: (r1, r2) => r1 !== r2,
    // });
    let posSearchData = this.props.data;
    let firstThreeDataList = slice(posSearchData, 0, 3);
    this.state = {
      dataSource: posSearchData, 
      dataSource1: firstThreeDataList
    }
    // this.state = {
    //   dataSource: ds.cloneWithRows(this.props.data),
    //   dataSource1: ds1.cloneWithRows(firstThreeDataList),
    // };
  }

  componentDidMount() {
    this.setState({
      dataSource: this.props.data//this.state.dataSource.cloneWithRows(this.props.data),
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataSource: nextProps.data//this.state.dataSource.cloneWithRows(nextProps.data),
    });
  }
  showAllContent() {
    const { showFullList } = this.state;
    this.setState({ showFullList: true });
    this.props.search.setHideCIOList(false);
  }
  renderListSpecificData(sData, dSource) {
    return (
      <NavigationList fullWidth style={{ marginBottom: 15 }}>
        {dSource.map((item, rowID) => (
          <NavigationListItem>
            <Row key={rowID} selectedRow={this.props.selectedRow} {...item} />
          </NavigationListItem>
        ))}
      </NavigationList>

      // <ListView
      //   style={styles.listStyle}
      //   dataSource={dSource}
      //   scrollEnabled={true}
      //   renderRow={(sData) => (
      //     <Row selectedRow={this.props.selectedRow} {...sData} />
      //   )}
      // />
    );
  }

  renderFirstThreeRow() {
    const { data, i18n: { messages } } = this.props;
    const firstThree = slice(this.props.data, 0, 3);
    const firstThreeRowContent = this.renderListSpecificData(
      firstThree,
      this.state.dataSource1
    );
    const fullListContent = this.renderListSpecificData(
      data,
      this.state.dataSource
    );

    return (
      <View>
        {!this.state.showFullList && firstThreeRowContent}

        {!this.state.showFullList && (
          <TouchableOpacity
            style={styles.showAll}
            onPress={() => this.showAllContent()}
          >
            <View style={styles.seeAllContent}>
              <div>
                <Small secondary>{messages['app.Search.seeAll']}</Small>
              </div>
              <div className="margin-left-10">
                <NavigationArrow size="normal" />
              </div>
            </View>
          </TouchableOpacity>
        )}

        {this.state.showFullList && fullListContent}
      </View>
    );
  }

  renderList() {
    const { data, search: { hidePositionList } } = this.props;

    if (data.length > 3) {
      return this.renderFirstThreeRow();
    } else {
      return (
        <NavigationList fullWidth style={{ marginBottom: 15 }}>
          {this.state.dataSource.map((item, rowID) => (
            <NavigationListItem>
              <Row key={rowID} selectedRow={this.props.selectedRow} {...item} />
            </NavigationListItem>
          ))}
        </NavigationList>
        // <ListView
        //   style={styles.listStyle}
        //   dataSource={this.state.dataSource}
        //   scrollEnabled={true}
        //   renderRow={(data, index) => (
        //     <Row selectedRow={this.props.selectedRow} {...data} />
        //   )}
        // />
      );
    }
  }

  render() {
    const { search: { hidePositionList } } = this.props;
    if (hidePositionList) {
      return (
        <div className="search-grid">
          <div style={{
            marginTop: 20,
            marginBottom: 15,
          }}>{this.renderList()}</div>
        </div>
      );
    } else {
      return <View />;
    }
  }
}
export default createContainer({
  //$renderLoading: () => <LoadingCircle />,
  $queries: {
    search: {
      setHideCIOList: {
        $set: 'hideCIOList',
      },
      hideCIOList: true,
      hidePositionList: true,
    },
    i18n: {
      messages: true,
    },
  },
})(PortfolioPositionSearch);
